const sortCaseInsesitive = (a, b) => {
    return a.toLowerCase().localeCompare(b.toLowerCase())
}

/**
 * Check if the upload progress has completed
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const fileUploadCompleted = state => state.uploadProgress === 100

/**
 * Check if there are mappings available from a file upload
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasMappings = state => Object.keys(state.mapping).length > 0

/**
 * Check if there is parsed data available from a file upload
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasParsedData = state => Object.keys(state.parsed_data).length > 0

/**
 * Return alphabetically sorted list of labels
 *
 * @param  {Object}
 * @return {Array}
 */
const localFields = state => {
    return Object
        .keys(state.mapping)
        .reduce((sum, key) => sum.concat(state.mapping[key].map(item => item.label)), [])
        .sort(sortCaseInsesitive)
}

/**
 * Return the alphbetically sorted keys on the parsed data object
 *
 * @param  {Object} state
 * @return {Array}
 */
const submittedFields = state => Object.keys(state.parsed_data).sort(sortCaseInsesitive)

export default {
    localFields,
    hasMappings,
    hasParsedData,
    submittedFields,
    fileUploadCompleted
}



// WEBPACK FOOTER //
// ./src/state/modules/rental-income-importer/getters.js